import React, { useEffect } from 'react';
import './instapagostStyle.css';

function ProductClientData({productData, saleOrderData, tasaBancaria, initialPaymentTerm, setTotalAmountToPay  }) {
     
    const truncateFixed = (num, decimals) => {
        const factor = Math.pow(10, decimals);
        return Math.trunc(num * factor) / factor;
    };

    const orderDataProductsDetails = {
        subTotal: truncateFixed(saleOrderData.billSubtotal, 2),
        iva: truncateFixed(saleOrderData.billTax, 2),
        totalAmount: truncateFixed(saleOrderData.billTotal, 2),
        missing: truncateFixed(saleOrderData.billResidualAmount, 2)
    }
    const roundUpSecondDecimal = (amount) => {
        return Math.ceil(amount * 100) / 100;
    }
    const amountTotalInBs = (totalValue) =>{
        let value = 0;
        if(!totalValue) value = saleOrderData?.billTotal * saleOrderData?.rateBs;
        else value = totalValue * saleOrderData?.rateBs;
        return truncateFixed(roundUpSecondDecimal(value) ,2)
    }
    const amountTotalToPay = () =>{
        if(initialPaymentTerm && initialPaymentTerm.amountToPayToday){
            if( initialPaymentTerm.amountToPayToday < orderDataProductsDetails.totalAmount){
                return initialPaymentTerm.amountToPayToday
            }else {
                return orderDataProductsDetails.totalAmount
            }
        }
        return orderDataProductsDetails.totalAmount
    }
    // const faltante = saleOrderData.billResidualAmount !== saleOrderData.billTotal
    
    useEffect(() => {
        const calculateTotalToPay = () => {
            if(initialPaymentTerm && initialPaymentTerm.amountToPayToday){
                if( initialPaymentTerm.amountToPayToday < orderDataProductsDetails.totalAmount){
                    return initialPaymentTerm.amountToPayToday
                }else {
                    return orderDataProductsDetails.totalAmount
                }
            }
            return orderDataProductsDetails.totalAmount
        }
        
        const totalValue = calculateTotalToPay()
        let value = 0;
        if(!totalValue) value = saleOrderData?.billTotal * saleOrderData?.rateBs;
        else value = totalValue * saleOrderData?.rateBs;
        const totalInBs = truncateFixed(roundUpSecondDecimal(value) ,2)
        
        setTotalAmountToPay(totalInBs)
    }, [saleOrderData, initialPaymentTerm, setTotalAmountToPay, orderDataProductsDetails])
    
    return (
    <div>
        <div className="row">
            <div className="col-12">
                <div className="table-responsive mb-4" style={{boxShadow: '1px 1px 5px 4px #00000029', borderRadius: '.35rem'}}>
                    <table className="table table-hover border-0" style={{ borderRadius: '8px', overflow: 'hidden' }}>
                        <thead className="bg-light">
                            <tr>
                                <th scope="col" className='d-none d-md-block text-center border-none' style={{ width: '60px', fontSize: '0.9rem', border: 'none' }}>
                                    {/* <i className="fas fa-hashtag text-muted"></i> */}
                                </th>
                                <th scope="col" className="fw-semibold" style={{ fontSize: '0.9rem' }}>
                                    <i className="fas fa-box me-2 text-primary"></i>
                                    Producto
                                </th>
                                <th scope="col" className="text-center fw-semibold" style={{ fontSize: '0.9rem' }}>
                                    <i className="fas fa-sort-numeric-up me-2 text-primary"></i>
                                    Cantidad
                                </th>
                                <th scope="col" className="text-end fw-semibold" style={{ fontSize: '0.9rem' }}>
                                    <i className="fas fa-dollar-sign me-2 text-primary"></i>
                                    Precio Unit.
                                </th>
                                <th scope="col" className="text-end fw-semibold" style={{ fontSize: '0.9rem' }}>
                                    <i className="fas fa-calculator me-2 text-primary"></i>
                                    Subtotal
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {productData.map((value, index) => (
                                <tr key={index} className="border-bottom">
                                    <td className='d-none d-md-block text-center text-muted fw-bold' style={{ fontSize: '0.9rem' }}>
                                        {index + 1}
                                    </td>
                                    <td className="fw-medium" style={{ fontSize: '0.9rem' }}>
                                        {value.productId[1]}
                                    </td>
                                    <td className="text-center">
                                        <span className="badge bg-primary rounded-pill text-white" style={{ fontSize: '0.8rem' }}>
                                            {value.quantity_order}
                                        </span>
                                    </td>
                                    <td className="text-end fw-semibold" style={{ fontSize: '0.9rem' }}>
                                        ${truncateFixed(value.unit_price, 2)}
                                    </td>
                                    <td className="text-end fw-bold text-success" style={{ fontSize: '0.9rem' }}>
                                        ${truncateFixed(value.subtotal, 2)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="totalPrice w-full ml-auto pt-2" style={{boxShadow: '1px 1px 5px 4px #00000029', borderRadius: '.35rem', maxWidth: 310}}>
                    <h4 className='text-center mb-3'>Resumen de pago</h4>
                    <table className="table mb-0" style={{ fontSize: 15 }}>
                        <tbody>
                            <tr style={{ backgroundColor: '#0000000d' }}>
                                <td><p className='m-0 fw-bold' style={{fontWeight:'600'}}>Subtotal:</p></td>
                                <td className="text-end">{truncateFixed(orderDataProductsDetails.subTotal, 2)}$</td>
                                <td className="text-end">{truncateFixed(amountTotalInBs(orderDataProductsDetails.subTotal), 2)}Bs</td>
                            </tr>
                            <tr>
                                <td><p className='m-0 fw-bold' style={{fontWeight:'600'}}>IVA:</p></td>
                                <td className="text-end">{truncateFixed(orderDataProductsDetails.iva, 2)}$</td>
                                <td className="text-end">{truncateFixed(amountTotalInBs(orderDataProductsDetails.iva), 2)}Bs</td>
                            </tr>
                            {
                               orderDataProductsDetails.totalAmount !== amountTotalToPay() && (
                                <tr style={{ backgroundColor: '#0000000d' }}>
                                    <td><p className='m-0 fw-bold' style={{fontWeight:'600'}}>Monto total:</p></td>
                                    <td className="text-end">{truncateFixed(orderDataProductsDetails.totalAmount, 2)}$</td>
                                    <td className="text-end">{truncateFixed(amountTotalInBs(), 2)}Bs</td>
                                </tr>
                               )
                            }
                            <tr>
                                <td>
                                    <p className='m-0 fw-bold' style={{fontWeight:'bold', fontSize:16}}>Total a pagar:</p>
                                </td>
                                <td className="text-end fw-bold">{truncateFixed(amountTotalToPay(), 2)}$</td>
                                <td className="text-end fw-bold">{truncateFixed(amountTotalInBs(amountTotalToPay()), 2)}Bs</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>  
    </div>
  )
}

export default ProductClientData
